import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Message } from "primereact/message";

interface CashReportRow {
  userID: number;
  userName: string;
  collectedAmount: number;
  receivedAmount: number;
  handedOverAmount: number;
  currentlyHolding: number;
}

interface CashReportDatatableProps {
  data: CashReportRow[];
  loading: boolean;
  reportTime?: string | null;
  onReceivedAmountClick: (row: CashReportRow) => void; 
  onHandoverAmountClick: (row: CashReportRow) => void;
  onCollectedAmountClick: (row: CashReportRow) => void;
}

const CashReportDatatable: React.FC<CashReportDatatableProps> = ({
  data,
  loading,
  reportTime,
  onReceivedAmountClick,
  onHandoverAmountClick,
  onCollectedAmountClick
}) => {
  const toast = useRef<Toast>(null);


  return (
    <div className="card border-noround p-2">
      <Toast ref={toast} position="top-right" />

  {reportTime && (
  <Message
    severity="info"
    text={`Report generated: ${reportTime}`}
    className="mb-2"
  />
)}
   
      <DataTable
        value={data}
        loading={loading}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50, 100]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column field="userName" header="Name" style={{ width: "15%" }} sortable/>
        <Column field="collectedAmount" 
                header="Collected Amount"
              style={{ width: "15%", cursor: "pointer" }}
              body={(rowData) => (
                <span onClick={() => onCollectedAmountClick(rowData)}>
                  {rowData.collectedAmount.toFixed(2)}
              </span>
                )}
                sortable
          />
      <Column
      field="receivedAmount"
      header="Received Amount"
      style={{ width: "15%", cursor: "pointer" }}
          body={(rowData) => (
            <span
              onClick={() => onReceivedAmountClick(rowData)}
            >
              {rowData.receivedAmount.toFixed(2)}
            </span>
          )}
      sortable
      />
        <Column field="handedOverAmount" 
        header="Handedover Amount"
        style={{ width: "15%", cursor: "pointer" }}
          body={(rowData) => (
            <span
              onClick={() => onHandoverAmountClick(rowData)}
            >
              {rowData.handedOverAmount.toFixed(2)}
            </span>
          )}
         sortable/>
        <Column field="currentlyHolding" header="Currently Holding Amount" style={{ width: "20%" }} sortable/>
        
      </DataTable>

    
    </div>
  );
};

export default CashReportDatatable;
